import { Static, Union } from "runtypes";

import { getNormalEnum } from "../runtypeEnums.js";

import { AnthropicModelLiteral } from "./anthropicTypes.js";
import { KimiModelLiteral } from "./chatCompletionsTypes.js";
import { OpenAiChatModelLiteral } from "./openAiTypes.js";

export const ModelNameLiteral = Union(
  ...AnthropicModelLiteral.alternatives,
  ...OpenAiChatModelLiteral.alternatives,
  ...KimiModelLiteral.alternatives,
);
export type ModelName = Static<typeof ModelNameLiteral>;
export const ModelName = getNormalEnum(ModelNameLiteral);

/**
 * Coerce a persisted thread model value for GraphQL and runtime resolution.
 * Returns null for values that are no longer recognized ModelName enum members.
 */
export function resolvePersistedModelName(
  model: string | null | undefined,
): ModelName | null {
  if (model == null) {
    return null;
  }
  return ModelNameLiteral.guard(model) ? model : null;
}

/**
 * Find the matching, currently-usable picker option for a model name. Returns
 * `undefined` when `model` is null/"auto" or when the model is absent or
 * disabled in `options`.
 */
export function findAvailableModelOption<
  T extends { model: ModelName | null; disabled: boolean },
>(options: readonly T[], model: ModelName | null): T | undefined {
  if (model == null) {
    return undefined;
  }
  return options.find((opt) => opt.model === model && !opt.disabled);
}
